import { MapPin } from 'lucide-react';
import { useLocationStore } from '@/stores/location-store';
import { useLocations } from '@/hooks/use-locations';
import { isWarehouseType } from '@/lib/location-type';

export function LocationBadge() {
  const { selectedLocationId, selectedLocationName } = useLocationStore();
  const { data: locationsData } = useLocations({ enabled: !!selectedLocationId });
  if (!selectedLocationId) return null;
  const selected = locationsData?.data?.find((l: any) => l.id === selectedLocationId);
  const isWarehouse = isWarehouseType(selected?.type);
  const colorCls = isWarehouse ? 'bg-orange-100 text-orange-700' : 'bg-primary/10 text-primary';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-medium ${colorCls}`}>
      <MapPin className="h-3.5 w-3.5" />
      {selectedLocationName || 'Current Location'}
    </span>
  );
}
